import React from 'react';
import BaseEntityList from './BaseEntityList';
import { EntityDesc } from './BaseAddEntityPopup/BaseAddEntityPopup';
import Terra from 'services/apis/terra/Terra';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { Market } from 'data/terra/Market';
import { fetchMarkets } from 'containers/store/common/actions/FetchMarkets';

function ListMarket() {
  const dispatch = useDispatch();
  const { markets } = useSelector((state: RootState) => state.common);

  return (
    <BaseEntityList<Market>
      entityName="Market"
      entities={markets}
      itemsPerRow={6}
      onEntitySelected={() => {}}
      onSaveEntity={async (desc: EntityDesc) => {
        return Terra.market.addMarket(desc);
      }}
      onSaveEntityResult={result => {
        if (result.isSuccess()) {
          dispatch(fetchMarkets());
        }
      }}
    />
  );
}

export default ListMarket;
